import styled from "styled-components";
import { COLORS } from "../../shared";
import { MEDIA_QUERY } from "../../entities/Common";

export const MixtureListStyled = styled.div`
  min-height: 470px;
  > div {
    min-height: inherit;
  }
  .mixture {
    &-error {
      color: red;
      position: absolute;
      left: 0;
      top: 100%;
      font-style: italic;
      font-size: 12px;
    }
    &-name {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      &__icon {
        svg {
          width: 20px;
          height: 20px;
          &.has-error {
            path {
              fill: red;
            }
          }
        }
      }
      &__input {
        margin-left: 5px;
        position: relative;
        input {
          border: none;
          height: 33px;
          outline: none;
          font: normal normal normal 16px/18px Arial;
          border-bottom: 1px solid ${COLORS.PRIMARY_DARK};
          &.has-error {
            border-bottom: 1px solid red;
            color: red;
            &::placeholder {
              color: red;
            }
          }
        }
      }
    }
    &-instruction {
      font: normal normal normal 16px/18px Arial;
      font-weight: 800;
      margin-bottom: 20px;
    }
    &-labels {
      display: flex;
      justify-content: space-between;
    }
    &-label {
      display: flex;
      align-items: center;
      &:nth-child(1) {
        width: calc(100% - 170px);
      }
      &:nth-child(2) {
        width: 170px;
        justify-content: center;
      }
      span {
        color: #bfbfbf;
        font: normal normal normal 16px/18px Arial;
        &:nth-child(2) {
          margin-left: 5px;
        }
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.LAPTOP}) {
    .mixture {
      &-instruction {
        font: 800 14px / 16px Arial;
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.TABLET_HORIZONTAL}) {
    .mixture {
      &-item {
        &__right {
          width: 130px;
        }
        &__control {
          height: 100%;
        }
        &__decrement,
        &__increment {
          width: 25px;
          height: 25px;
        }
        &__count {
          font-size: 14px;
        }
      }
      &-label {
        span {
          font: 14px / 16px Arial;
        }
        &:nth-child(2) {
          width: 130px;
        }
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    .mixture {
      &-instruction {
        font: 800 14px / 18px Arial;
      }
      &-name {
        &__input {
          input {
            height: 30px;
            font-size: 14px;
          }
        }
      }
      &-item {
        &__image {
          width: 70px;
        }
        &__info {
          width: calc(100% - 80px);
        }
        &__right {
          width: 100px;
        }
        &__left {
          width: calc(100% - 100px);
        }
        &__count {
          font-size: 12px;
        }
      }
    }
  }
`;
